import { useContext } from "react";
// import { SessionTimeoutMsg } from "../../App";
import { useTheme, Text, View, Alert } from "@aws-amplify/ui-react";
import "./Login.css";

export const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <div className="loginView">
          <img src={`${process.env.PUBLIC_URL}/symbol-color-min.jpg`} width="50px" alt="株式会社東京商工リサーチ" title="東京商工リサーチ" />
        </div>
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]} >
          &copy; 2025 TOKYO SHOKO RESEARCH, LTD.
        </Text>
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <div hidden>
          <div className="logout">
            <Alert hasIcon={true} variation="error">
              一定時間操作が行なわれなかったためログアウトしました。再度ログインしてください。
            </Alert>
          </div>
        </div>
      );
    },
    Footer() {
        return <>&nbsp;</>;
    }
  }
};
